import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';
import { media } from '~/utils';

export default function Activity({ number, activity, large = false, onClick }) {
  return (
    <Wrapper large={large}>
      <Left large={large}>
        <Title>
          <Futura>{number}</Futura>
          活動内容
        </Title>
        <TitleText>{activity.title}</TitleText>
        <Text large={large}>{activity.text}</Text>
      </Left>
      <Right large={large}>
        <Image large={large} src={activity.image} alt='image-activity' />
      </Right>
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #696969;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;

  ${media.mid`
    border-radius: 0;
    flex-direction: column-reverse;
    width: 100%;
  `}

  ${(props) =>
    props.large &&
    `
    height: auto;
    flex-direction: column !important;
  `}
`;

const Left = styled.div`
  flex: 1;
  display: -webkit-box;
  margin-bottom: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  ${media.mid`
    flex: initial;
    width: 100%;
  `}

  ${(props) =>
    props.large &&
    `
    height: auto !important;
  `}
`;

const Right = styled.div`
  flex: 1;

  ${media.mid`
    flex: initial;
    height: 200px;
  `}

  ${(props) =>
    props.large &&
    `
    height: auto !important;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  color: #2c2c2c;
  font-weight: bold;
  display: flex;
  color: #fff;
  font-size: 12px;
  position: relative;

  & > i {
    font-size: 18px;
    position: relative;
    top: -3px;
    margin-right: 10px;
  }
`;

const TitleText = styled.div`
  padding: 5px 15px 0px 35px;
  color: #fff;
  font-size: 24px;
  line-height: 32px;
  font-weight: bold;
  max-height: 64px;
  overflow: hidden;
`;

const Text = styled.div`
  padding: 5px 15px 0px 35px;
  color: #fff;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 1px;
  height: ${(props) => (props.large ? 'auto' : '96px')};
  overflow: hidden;
  text-align: justify;
  white-space: ${(props) => (props.large ? 'pre-wrap' : 'normal')};
`;

const Image = styled.img`
  width: 100%;
  height: 235px;
  object-fit: cover;

  ${media.mid`
    height: 200px;
  `}

  ${(props) =>
    props.large &&
    `
    margin: 20px 35px 40px;
    height: 350px;
    width: calc(100% - 70px);
  `}
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
  color: #fff;
`;
